export const SINGLE_CALL_BALANCE_CHECKER_CONTRACT_ADDRESS_MAINNET =
  '0xb1f8e55c7f64d203c1400b9d8555d050f94adf39';
export const ARGENT_GUARDIAN_MANAGER_CONTRACT_ADDRESS_MAINNET =
  '0xFF5A7299ff6f0fbAad9b38906b77d08c0FBdc9A7';
